export default {
  empty_list: 'Ei kategorioita vielä',
  uses_restaurant_open_times: 'Käyttää ravintolan aukioloaikoja',
  products_creation_disabled:
    'Koska integraatio {{integration}} on käytössä, uusien tuotteiden luominen ei ole sallittua. Jos haluat muuttaa valikkoa, tee muutokset palvelussa {{integration}} ja synkronoi valikko.',
  buttons: {
    add_category: 'Lisää kategoria',
  },
  toasts: {
    something_went_wrong: 'Jokin meni pieleen',
  },
};
